import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "pe-3"
}
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex-grow-1 pt-1" }
const _hoisted_6 = {
  key: 1,
  class: "ps-3"
}
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSlider = _resolveComponent("VueSlider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showMinMaxValues)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.bounds[0]), 1),
              (_ctx.percentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "%"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_VueSlider, {
          min: _ctx.bounds[0],
          max: _ctx.bounds[1],
          interval: _ctx.interval,
          modelValue: _ctx.sliderValue,
          tooltip: 'always',
          "tooltip-placement": 'top',
          "tooltip-formatter": _ctx.formatter,
          onChange: _ctx.changeValue,
          onDragEnd: _ctx.submitChange,
          "drag-on-click": true
        }, null, 8, ["min", "max", "interval", "modelValue", "tooltip-formatter", "onChange", "onDragEnd"])
      ]),
      (_ctx.showMinMaxValues)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.bounds[1]), 1),
              (_ctx.percentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "%"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}